import { render, staticRenderFns } from "./AppDropdownContent.vue?vue&type=template&id=8f8ef54c&scoped=true&"
import script from "./AppDropdownContent.vue?vue&type=script&lang=js&"
export * from "./AppDropdownContent.vue?vue&type=script&lang=js&"
import style0 from "./AppDropdownContent.vue?vue&type=style&index=0&id=8f8ef54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8ef54c",
  null
  
)

export default component.exports